import TooltipPro from 'epn-ui/umd/dist/components/TooltipPro';
import type { ITooltipProProps } from 'epn-ui/umd/dist/components/TooltipPro/types';

import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

interface IBaseIconTooltip {
    className?: React.ComponentProps<'div'>['className'];
    icon: FontAwesomeIconProps['icon'];
    text: ITooltipProProps['title'];
    placement?: ITooltipProProps['placement'];
}

const BaseIconTooltip: React.FC<IBaseIconTooltip> = ({
    className,
    icon,
    text,
    placement = 'top',
}) => (
    <TooltipPro title={text} placement={placement}>
        <FontAwesomeIcon className={`${className} cursor-help`} icon={icon} />
    </TooltipPro>
);

export default BaseIconTooltip;
